import { EarnWithdrawalRequestStatus } from "./earn-positions";

// Status-only predicate (no amount comparison) — stays at the domain layer because the queue slice
// consumes it on raw-bigint domain data. The amount-comparing predicates moved to the view layer
// (`types/view/earn-withdrawals.ts`) where amounts are `TokenAmount`.

/** Pending or Partial — the request is still active in the withdrawal queue. */
export function isOpenWithdrawalStatus(status: EarnWithdrawalRequestStatus): boolean {
    return status === EarnWithdrawalRequestStatus.Pending || status === EarnWithdrawalRequestStatus.Partial;
}
